export default __webpack_public_path__ + "static/media/hosting-editor.c9efe975.jpg";